import type { LegalAttachmentKind } from '../features/leads/utils/offerLegalAttachments';

/** PDF API URL scoped by instance + bust so browser cache cannot bleed across instances. */
export function companyLegalAttachmentSrc(
  instanceId: string,
  kind: LegalAttachmentKind,
  bust = 0,
): string {
  const i = encodeURIComponent(instanceId.trim() || 'default');
  const t = Number.isFinite(bust) ? Math.max(0, Math.floor(bust)) : 0;
  return `/api/settings/company/legal-attachments/${encodeURIComponent(kind)}?instance=${i}&t=${t}`;
}
